import { createBrowserRouter, Navigate } from 'react-router-dom';

import { AuthLayout } from '@/layouts/AuthLayout';
import { TenantLayout } from '@/layouts/TenantLayout';
import { ProtectedRoute } from '@/components/ProtectedRoute';

import { LoginPage } from '@/pages/auth/Login';
import { OtpPage } from '@/pages/auth/OtpPage';
import { InvitePage } from '@/pages/auth/Invite';
import { OnboardingPage } from '@/pages/auth/Onboarding';

import { DashboardPage } from '@/pages/tenant/Dashboard';
import { LeaseSignPage } from '@/pages/tenant/LeaseSign';
import { PaymentsPage } from '@/pages/tenant/Payments';
import { PaymentDetailPage } from '@/pages/tenant/PaymentDetail';
import { UtilitiesPage } from '@/pages/tenant/Utilities';
import { UtilitiesSubmitPage } from '@/pages/tenant/UtilitiesSubmit';
import { MaintenancePage } from '@/pages/tenant/Maintenance';
import { ContactsPage } from '@/pages/tenant/Contacts';
import { ChatPage } from '@/pages/tenant/Chat';
import { SearchPage } from '@/pages/tenant/Search';
import { ListingDetailPage } from '@/pages/tenant/ListingDetail';
import { ApplicationsPage } from '@/pages/tenant/Applications';
import { InspectionsPage } from '@/pages/tenant/Inspections';
import { ActsPage } from '@/pages/tenant/Acts';
import { ActDetailPage } from '@/pages/tenant/ActDetail';
import { TrustPassportPage } from '@/pages/tenant/TrustPassport';
import { ProfilePage } from '@/pages/tenant/Profile';

import { GuestPayPage } from '@/pages/guest/GuestPay';
import { GuestReadingsPage } from '@/pages/guest/GuestReadings';
import { GuestMaintenancePage } from '@/pages/guest/GuestMaintenance';
import { GuestSignPage } from '@/pages/guest/GuestSign';

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/login/otp', element: <OtpPage /> },
      { path: '/invite', element: <InvitePage /> },
      { path: '/onboarding', element: <OnboardingPage /> },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <TenantLayout />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'dashboard', element: <Navigate to="/" replace /> },
          { path: 'leases/:id/sign', element: <LeaseSignPage /> },
          { path: 'payments', element: <PaymentsPage /> },
          { path: 'payments/:id', element: <PaymentDetailPage /> },
          { path: 'utilities', element: <UtilitiesPage /> },
          { path: 'utilities/submit', element: <UtilitiesSubmitPage /> },
          { path: 'maintenance', element: <MaintenancePage /> },
          { path: 'contacts', element: <ContactsPage /> },
          { path: 'chat', element: <ChatPage /> },
          { path: 'search', element: <SearchPage /> },
          { path: 'search/:id', element: <ListingDetailPage /> },
          { path: 'applications', element: <ApplicationsPage /> },
          { path: 'inspections', element: <InspectionsPage /> },
          { path: 'acts', element: <ActsPage /> },
          { path: 'acts/:id', element: <ActDetailPage /> },
          { path: 'trust-passport', element: <TrustPassportPage /> },
          { path: 'profile', element: <ProfilePage /> },
        ],
      },
    ],
  },
  // Guest signed-URL pages (no auth, no layout).
  { path: '/guest/pay/:paymentId', element: <GuestPayPage /> },
  { path: '/pay/:paymentId', element: <GuestPayPage /> },
  { path: '/guest/readings/:leaseId/:month/:year', element: <GuestReadingsPage /> },
  { path: '/readings/:leaseId/:month/:year', element: <GuestReadingsPage /> },
  { path: '/guest/maintenance/:leaseId', element: <GuestMaintenancePage /> },
  { path: '/guest/sign/:documentId', element: <GuestSignPage /> },
  { path: '/sign/:documentId', element: <GuestSignPage /> },
  { path: '*', element: <Navigate to="/" replace /> },
]);
